module.exports = __webpack_public_path__ + "img/selected5-min.c2218343.png";